
import { Component, Inject, Vue } from 'vue-property-decorator';

import { DesignerElement } from '../../models/designer-element.model';
import { DesignerStateProvider } from '../../designer.provider';

@Component({
  name: 'ed-designer-menu',
})
export default class EdDesignerMenu extends Vue {
  @Inject()
  readonly DesignerStateProvider: DesignerStateProvider;

  onOpenDesign(event: any) {
    const reader = new FileReader();

    reader.onload = (event) => {
      const elements = JSON.parse(event.target.result as string);

      this.DesignerStateProvider.setElementsFromJson(elements);
    };

    reader.readAsText(event.target.files[0]);
  }

  onSaveDesign() {
    this.DesignerStateProvider.clearSelection();

    const elements: DesignerElement[] = this.DesignerStateProvider.elements;

    if (elements) {
      const elementsFormatted = elements.map(e => e.getElementToSaveFormatted());
      const data = 'data:text/json;charset=utf-8,' + encodeURIComponent(
        JSON.stringify(elementsFormatted)
      );
  
      const filename = `${new Date().getTime().toString()}.json`;
      const link = document.createElement('a');
  
      link.download = filename;
      link.href = data;
      link.click();
    }
  }

  async onDownloadDesign() {
    const dataUrl = await this.DesignerStateProvider.getImageDesign();

    const link = document.createElement('a');
    const filename = `${new Date().getTime().toString()}.jpeg`;

    link.download = filename;
    link.href = dataUrl;
    link.click();
  }
}
